var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFechar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "70.000000pt",
    height: "70.000000pt",
    viewBox: "0 0 70.000000 70.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,70.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M270 631 c-47 -15 -85 -39 -126 -83 -57 -58 -74 -97 -81 -176 -9 -120 51 -227 162 -285 57 -30 193 -30 250 0 59 31 114 91 142 153 50 109 11 262 -84 335 -73 55 -186 79 -263 56z m164 -61 c38 -14 105 -79 128 -124 47 -91 11 -227 -75 -284 -163 -108 -369 -3 -369 188 0 96 45 163 147 219 25 13 135 14 169 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257 438 c-19 -20 -18 -21 14 -54 l33 -34 -28 -29 c-50 -52 -7 -95 45 -45 l29 28 28 -27 c33 -32 39 -33 64 -10 18 16 17 18 -14 50 l-32 33 32 33 32 33 -22 22 -22 22 -33 -32 -33 -32 -33 32 c-18 18 -35 32 -37 31 -3 0 -13 -10 -23 -21z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFechar);
export default __webpack_public_path__ + "static/media/icon_fechar.1d4c534fb66471cbfdf1fbb0271a7d70.svg";
export { ForwardRef as ReactComponent };